<template>
  <div>
    <a href="#" @click.stop.prevent="toggler = ! toggler">
      <slot></slot>
    </a>
    <fs-lightbox :toggler="toggler" :sources="sources" :type="type"></fs-lightbox>
  </div>
</template>

<script>
  export default{
    props: ['sources', 'type'],
    data() {
      return {
        toggler: false
      };
    }
  }
</script>

<style>
</style>
